import type { Module } from "vuex";
import type { State } from "@/store/state";
import type { SiteConfigState } from "./state";
import { mutations } from "./mutations";
import { getters } from "./getters";
import { actions } from "./actions";

const defaultState: SiteConfigState = {
  siteConfigurations: [],
  siteConfigurationsLoaded: false,
  projectTimeZone: "Etc/UTC",
  projectTimeZoneLoaded: false,
  demoMode: false,
  assuresrvVersion: null,
};

export const siteConfigModule: Module<SiteConfigState, State> = {
  namespaced: true,
  state: defaultState,
  mutations,
  actions,
  getters,
};
